import React, { Component } from 'react';
import AuthService from '../../services/api/auth';
import VerificationCode from './VerificationCode';

import Modal from 'react-modal';
import ReactPhoneInput from '../../external/react-phone-input.min';
import 'react-phone-input-2/lib/style.css';
import LoadingModal from '../../components/LoadingModal';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as registerActions from './actions/';
import { withAlert } from 'react-alert';
import ErrorList from '../../components/ErrorList';
import { setLanguage } from '../../redux/application/actions';
import { languageSelector } from '../../redux/application/selector';

class PersonalDetailsTwo extends Component {
    constructor(props) {
        super(props);

        this.state = {
            number: '',
            numberCountry: '',
            modalIsOpen: false,
            errors: [],
            country: window.VULOG_PHONE_NUMBER_COUNTRY,
        };
    }

    triggerModal() {
        this.setState({
            modalIsOpen: !this.state.modalIsOpen,
        });
    }

    componentDidMount() {
        //this is a new session, remove cookie;
        this.props.setStep('PHONE');
    }

    validateSms(code) {
        this.setState({
            loading: true,
        });
        AuthService.validateSms({
            code,
        })
            .then(() => {
                AuthService.getAccountStatus().then(response => {
                    if (response.next === null) {
                        this.props.history.push('/status');
                    } else {
                        this.props.history.push(response.next);
                    }
                });
            })
            .catch(error => {
                this.setState({
                    loading: false,
                });
                let errorMessage = 'DEFAULT_ERROR_MESSAGE';
                if (error && error.data && error.data.message) {
                    errorMessage = error.data.message;
                } else if (error && error.message) {
                    errorMessage = error.message;
                }
                this.setState({
                    errors: [errorMessage],
                });
            });
    }

    requestSms() {
        if (!this.checkIfNumberValid()) {
            return this.setState({
                errors: ['Number is not valid !'],
            });
        }

        this.setState({
            loading: true,
            errors: [],
        });

        AuthService.requestSms(this.state)
            .then(response => {
                this.setState({
                    loading: false,
                });
                if (response.skip) {
                    AuthService.getAccountStatus().then(response => {
                        if (response.next === null) {
                            this.props.history.push('/status');
                        } else {
                            this.props.history.push(response.next);
                        }
                    });
                } else {
                    if (!this.state.modalIsOpen) {
                        this.setState({
                            modalIsOpen: true,
                        });
                    }
                }
            })
            .catch(error => {
                if (error && error.data && error.data.message) {
                    this.setState({
                        loading: false,
                        errors: [error.data.message],
                    });
                } else {
                    this.setState({
                        loading: false,
                        errors: ['DEFAULT_ERROR_MESSAGE'],
                    });
                }
            });
    }

    checkIfNumberValid() {
        let parsedNumber = this.state.number.replace(/-/g, '');
        parsedNumber = parsedNumber.replace(/\D/g, '');
        if (!parsedNumber || parsedNumber.length < 9) {
            return false;
        }
        /* eslint-disable */
        return parsedNumber.match(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{3,9}$/im);
    }

    cancel() {
        AuthService.getAccountStatus().then((response) => {
            response.steps.forEach((entry, i) => {
                if (entry.path === this.props.location.pathname) {
                    if (entry.back) {
                        this.props.history.push(entry.back);
                    } else {
                        const lastScreen = response.steps[i - 1];
                        if (lastScreen && lastScreen.path) {
                            this.props.history.push(lastScreen.path);
                        }
                    }
                }
            });
        });
    }

    render() {
        return (
            <div className="container-fluid wrapper">
                <div className="d-flex flex-column full-height menu-bar-bottom">
                    <Modal
                        isOpen={this.state.modalIsOpen}
                        contentLabel={window.VULOG_TRANSLATE('Verification Code')}
                        shouldCloseOnOverlayClick={true}
                        shouldCloseOnEsc={true}

                        portalClassName="e-modal"
                        overlayClassName="e-modal__overlay"
                        className="e-modal__content"
                        bodyOpenClassName="e-modal--is-open"
                        htmlOpenClassName="prevent-scroll"
                        shouldFocusAfterRender={false}
                        ariaHideApp={false}

                        onRequestClose={() => this.setState({ modalIsOpen: false })}
                    >
                        <VerificationCode
                            onRequestClose={() => this.setState({ modalIsOpen: false })}
                            errors={this.state.errors}
                            phoneNumber={this.state.number}
                            onVerify={this.validateSms.bind(this)}
                            triggerModal={this.triggerModal.bind(this)}
                            resend={() => this.requestSms()} />
                    </Modal>
                    <h3 className="page__title">{window.VULOG_TRANSLATE('Personal Details')}</h3>
                    <h2 className="page__title-medium">{window.VULOG_TRANSLATE('PERSONAL_DETAILS_SUBTITLE')}</h2>
                    <div className="f-container flex-grow-1">
                        {window.VULOG_CONFIG && window.VULOG_CONFIG.ERROR_DISPLAY_TOP && <ErrorList errors={this.state.errors} />}
                        <form>
                            <div className="form-row mb-2">
                                <label htmlFor="phone-number" className="blue small col-4 mb-0">{window.VULOG_TRANSLATE('Phone Number')}</label>
                                <div className="col">
                                    <ReactPhoneInput
                                        disableAreaCodes={true}
                                        enableSearch={true}
                                        country={this.state.country}
                                        countryCodeEditable={false}
                                        value={this.state.number}
                                        onChange={(value, data) => {
                                            this.setState({
                                                number: value.replace(/[^0-9]+/g, ''),
                                                country: data.countryCode
                                            })
                                        }}
                                    />
                                </div>
                            </div>
                        </form>
                    </div>
                    {!window.VULOG_CONFIG.ERROR_DISPLAY_TOP && <ErrorList errors={this.state.errors} />}
                    <div className="d-flex flex-row mt-auto mb-1-5rem">
                        {this.props.position !== window.VULOG_CONFIG.STEPS[1].screen ? <button onClick={() => this.cancel()} className="btn btn-primary btn-block"><i className="material-icons va-middle reg">keyboard_arrow_left</i>{window.VULOG_TRANSLATE('Back')}</button> : null}
                        <button className="btn btn-primary btn-block" onClick={this.requestSms.bind(this)}>{window.VULOG_TRANSLATE('Next')}<i className="material-icons va-middle reg">keyboard_arrow_right</i></button>
                    </div>
                    <LoadingModal loading={this.state.loading} />
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    position: state.register.position,
    language: languageSelector(state),
});
/**
 * Get actions and pass them as props to Component
 * @param dispatch
 * @returns {{}|B|N}
 */

const mapDispatchToProps = dispatch => ({
    onRegisterActions: bindActionCreators(registerActions, dispatch),
    onSetLanguage: bindActionCreators(setLanguage, dispatch),
});

export default withAlert(connect(mapStateToProps, mapDispatchToProps)(PersonalDetailsTwo));